document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('product-form.product-form--locked').forEach(function (pf) {
    pf.addEventListener('click', function (e) {
      if (!pf.classList.contains('product-form--locked')) return;
      e.preventDefault();
      e.stopPropagation();
      var note = pf.querySelector('.product-form__select-size-note');
      if (note) {
        note.hidden = false;
        note.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  });

  document.addEventListener('change', function (e) {
    var vs = e.target.closest('variant-selects');
    if (!vs) return;
    var scope = vs.closest('.shopify-section, .popup-modal__content__data') || document;
    var pf = scope.querySelector('product-form.product-form--locked');
    if (pf) {
      pf.classList.remove('product-form--locked');
      var note = pf.querySelector('.product-form__select-size-note');
      if (note) note.hidden = true;
    }
  });
});